import Et3Button from "../../../../../../../core/et3-button";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";

const NonePendingResolve = withLiteObserverAndTheme<{
  dataStatusIsPending: boolean;
  changeDataStatus: () => Promise<void>;
}>((props) => {
  const { theme, dataStatusIsPending, changeDataStatus } = props;
  const { colors } = theme;

  return !dataStatusIsPending ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={150}
      height={55}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        type="GET"
        isEnabled={true}
        onClick={async () => await changeDataStatus()}
        size="MEDIUM"
        text="CHANGE_STATUS"
      />
    </ET3Div>
  ) : null;
});

export default NonePendingResolve;
